<template>
  <div class="omnistock omni-card">
    <OmniCardHeader v-if="this.$slots.header">
        <slot name="header" />
    </OmniCardHeader>

    <OmniCardBody v-if="this.$slots.default">
        <slot />
    </OmniCardBody>

    <OmniCardFooter v-if="this.$slots.footer">
        <slot name="footer" />
    </OmniCardFooter>
  </div>
</template>

<style lang="scss">
.omnistock {
    &.omni-card {
        $border-color: rgba(0, 0, 0, 0.125);
        $box-shadow: 0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03), 0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03), 0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05), 0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);

        border: 1px solid $border-color;
        border-radius: 0.25rem;
        background-color: #fff;
        box-shadow: $box-shadow;
        word-wrap: break-word;


        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;

        margin-bottom: 1rem;

        .omni-card {
            // When the OmniCard is nested inside another OmniCard, we want to use a different background color,
            // less box-shadow and a lighter border surrounding the card.
            box-shadow: 2px 2px 10px rgba(90,90,160,.15);
            background: rgba(200,200,240,.1);
            border: 1px solid rgba(0,0,0,.075)
        }

        // // Separator line between header and body
        // > *:not(:last-child) {
        //     border-bottom: 1px solid $border-color;
        // }
    }
}
</style>

<script>
import Vue from "vue";
import OmniCardHeader from "./OmniCard/OmniCardHeader.vue";
import OmniCardBody   from "./OmniCard/OmniCardBody.vue";
import OmniCardFooter from "./OmniCard/OmniCardFooter.vue";

export default Vue.extend({
    name: "OmniCard",
    components: {
        OmniCardHeader,
        OmniCardBody,
        OmniCardFooter,
    },
});
</script>
